<div class="d-flex justify-content-between"
     *ngFor="let img of images; let ind=index"
     [class.mt-1]="ind">
  <div class="info-item-img me-3 pointer">
    <img [src]="img.image | multiImage: 'smallUrl' : true : ''"
         (click)="onShowImage.emit(img.originalUrl)">
  </div>

  <div class="info-item-desc font-md w-100">
    {{ img.description }}
  </div>
</div>
